import styled, { css } from 'styled-components';
import { remCalc, colors, media } from '@prisjakt/ui-base';

export const UserReviewRow = styled.div`
  margin-top: ${remCalc(10)};
  margin-bottom: ${remCalc(30)};

  ${media.mediumUp`
    margin-bottom: ${remCalc(40)};
  `}
`;

export const MainBlock = styled.div`
  position: relative;
  max-width: 100%;
`;

export const Edit = styled.div`
  position: absolute;
  top: 2px;
  right: 45px;
`;

export const TextLabel = styled.div`
  margin-top: ${remCalc(10)};
  white-space: pre-line;
  font-weight: 400;
  color: ${colors.darkBlue1};
  max-height: 9ex;
  overflow: hidden;

  ${props =>
    props.fullText &&
    css`
      max-height: none;
    `}
`;

export const ReadMore = styled.button`
  color: ${p => p.theme.text.linkExternal};
  text-decoration: underline;

  &:hover {
    color: ${p => p.theme.text.linkExternalHover};
    cursor: pointer;
  }
`;

export const User = styled.div`
  display: flex;
  align-items: center;

  ${media.mediumDown`
    margin-top: ${remCalc(10)};
  `}
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-content: space-around;
  overflow: hidden;
  font-size: ${remCalc(12)};
`;

export const UsernameLabel = styled.span`
  color: ${p => p.theme.text.tertiary};
`;

export const ReviewCountLabel = styled.span`
  color: ${colors.mediumGray2};
  white-space: nowrap;
`;

export const UserAvatar = styled.div`
  flex-shrink: 0;
  margin-right: ${remCalc(5)};
`;

export const Rating = styled.div`
  display: flex;

  ${media.mediumDown`
    align-items: center;
  `}

  ${media.largeUp`
    flex-direction: column;
  `}
`;

export const DateLabel = styled.div`
  color: ${p => p.theme.text.secondary};

  ${media.mediumDown`
    margin-left: ${remCalc(10)};
    margin-bottom: -3px;
  `}

  ${media.largeUp`
    ${props =>
      props.createdDate &&
      css`
        margin-top: ${remCalc(10)};
      `}
  `}

  ${props =>
    props.editDate &&
    props.purchaseDate &&
    css`
      color: ${p => p.theme.text.tertiary};
    `}
`;

export const TranslationOptions = styled.div`
  display: flex;
  justify-content: flex-end;
  color: ${p => p.theme.text.tertiary};
`;

export const TranslationOptionsService = styled.div`
  margin-right: 1em;
  img {
    margin-top: 2px;
    height: 18px;
  }
`;

export const TranslationOptionsToggle = styled.div`
  button {
    cursor: pointer;
    color: ${p => p.theme.text.tertiary};
    text-decoration: underline;
  }
`;

export const Actions = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  svg {
    fill: ${p => p.theme.icons.tertiary};
    &:hover {
      fill: ${colors.darkGray3};
    }
  }

  .ui-dropdown--toggle-button {
    padding-top: 0;
    padding-bottom: 0;
  }

  ${media.mediumDown`
    top: 10px;
  `}
`;

export const Reply = styled.div`
  background-color: ${colors.semiWhite};
  margin-top: ${remCalc(20)};
  padding: ${remCalc(10)};
  border-radius: ${remCalc(6)};
`;

export const ReplyName = styled.div`
  margin-bottom: ${remCalc(3)};
  color: ${colors.darkGray1};
  font-size: ${remCalc(12)};
`;

export const ReplyDate = styled.span`
  float: right;
`;

export const ReplyText = styled.div`
  white-space: pre-line;
`;
